import { ImageSourcePropType } from 'react-native';

import {
	RankingsBronzePng,
	RankingsDiamondPng,
	RankingsGoldPng,
	RankingsPlatinumPng,
	RankingsSilverPng,
} from '../../../assets';
import { DuelShieldJpg } from '../../../assets/duels';
import { groupThousands } from '../Event/eventTheme';

export const duelColors = {
	positive: '#2FE07A',
	negative: '#FF5A4A',
	muted: '#C9B7A6',
	youRow: 'rgba(255,199,71,0.18)',
	youBorder: '#FFD766',
	row: 'rgba(0,0,0,0.28)',
	settled: '#2FE07A',
} as const;

export const DUEL_PANEL_FILL: Array<[string, string]> = [
	['0', '#2A0804'],
	['1', '#120302'],
];

export const DUEL_SECONDARY_FILL: Array<[string, string]> = [
	['0', '#4E0100'],
	['1', '#2A0100'],
];

const DIVISION_BADGES: Record<string, ImageSourcePropType> = {
	bronze: RankingsBronzePng,
	silver: RankingsSilverPng,
	gold: RankingsGoldPng,
	platinum: RankingsPlatinumPng,
	diamond: RankingsDiamondPng,
};

export const divisionBadge = (divisionName: string | null | undefined): ImageSourcePropType =>
	DIVISION_BADGES[(divisionName ?? '').trim().toLowerCase()] ?? DuelShieldJpg;

export const formatScore = (value: number | null | undefined) =>
	value === null || value === undefined ? '—' : groupThousands(value);

export const formatSigned = (value: number) =>
	`${value > 0 ? '+' : value < 0 ? '−' : ''}${groupThousands(Math.abs(value))}`;

export const deltaColor = (value: number) =>
	value > 0 ? duelColors.positive : value < 0 ? duelColors.negative : duelColors.muted;

export const daysUntil = (iso: string | null | undefined, now = Date.now()) =>
	iso ? Math.max(0, Math.ceil((new Date(iso).getTime() - now) / 86_400_000)) : null;

export const durationParts = (ms: number) => {
	const totalSeconds = Math.max(0, Math.round(ms / 1000));
	return { minutes: Math.floor(totalSeconds / 60), seconds: totalSeconds % 60 };
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatSettledAt = (iso: string, separator = ' · ') => {
	const date = new Date(iso);
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}${separator}${hours}:${minutes}`;
};
